import { render, staticRenderFns } from "./SPetshopTipo.vue?vue&type=template&id=6e67460e"
import script from "./SPetshopTipo.vue?vue&type=script&lang=js"
export * from "./SPetshopTipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports